import React from 'react';
import Masonry from 'react-responsive-masonry';
import { GalleryImageItem } from '@/app/_api/fetchGalleryContent';
import { Media } from '../Media';

import classes from './GalleryImageGrid.module.scss';

interface GalleryImageGridProps {
  images: GalleryImageItem[];
  cols?: number;
  mobileCols?: number;
}

export const GalleryImageGrid: React.FC<GalleryImageGridProps> = ({
  images,
  cols = 3,
  mobileCols = 2
}) => {
  if (images.length === 0) {
    return <p className={classes.empty}>No gallery images found with current filters.</p>;
  }

  const columnsCountBreakPoints = {
    350: mobileCols,
    768: cols
  };

  return (
    <Masonry
      className={classes.grid}
      columns={columnsCountBreakPoints}
    >
        {images.map((item) => (
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          <Media key={item.id ?? undefined} resource={item.image as any} alt={item.image?.alt || item.title || ''} className={classes.image} />
        ))}
    </Masonry>
  );
};

export default GalleryImageGrid;
